import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import Crypto from 'crypto-js';
import { Platform } from 'ionic-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { LegacyPageOptions } from '../../model/authentication.model';
import { GDAuthInterface } from '../../model/gd-auth';
import { GDStorageInterface } from '../../model/gd-storage';
import { FcmNative } from '../../native/fcm.native';
import { PageBuilderGlobal } from '../../pagebuilder/providers/global';
import { EnkripsiProvider } from '../../providers/enkripsi/enkripsi';
import { FcmServiceProvider } from '../../providers/fcm-service/fcm-service';
import { GlobalServiceProvider } from '../../providers/global-service/global-service';
import { PlatformServiceProvider } from '../../providers/platform/platform-service';
import { Sha1Service } from '../../providers/secrypt';
import { SimProvider } from '../../providers/sim/sim.service';
import { AppPreferences, Preference } from '../../shared/local/app-preferences.local';
import { LoginForms, LoginRequest, RequestRefreshTokenDto } from '../../shared/nestjs/gd-only/dto/auth.dto';
import { MultipleAccount } from '../../shared/nestjs/gd-only/dto/multiple-acocunt.dto';
import { AuthApi } from '../../shared/nestjs/gd-only/services/auth.api';
import { CoreAuthApi } from '../../shared/nestjs/gd-only/services/core-auth.api';
import { NestApiProvider } from '../../shared/nestjs/nest-api';
import { NestAuthProvider } from '../../shared/nestjs/nest-auth';
import { NestResponsesProvider } from '../../shared/nestjs/nest-responses';
import { RequestAuth } from '../../shared/recruitment/dto/auth.dto';
import { RecruitmentAuth } from '../../shared/recruitment/recruitment-auth';
import { AuthApi as RecruitmentAuthApi } from '../../shared/recruitment/services/auth.api';
import { LoopBackConfig, RegistrationNewApi } from '../../shared/sdk';
import { SunfishApi } from '../../shared/sdk/services/custom/Sunfish';
import { PollingBloc } from '../feature/polling/polling.bloc';
import { AttendanceBloc } from '../hr/attendance/attendance.bloc';
import { ShiftscheduleBloc } from '../hr/shift/shiftschedule.bloc';
import { ChangeAccessBloc } from '../settings/change-access.bloc';
import { ChangePasswordBloc } from '../settings/change-password.bloc';
@Injectable()
export class AuthenticationBloc {

    constructor(
        private http: Http,
        private storage: Storage,
        private sunfishApi: SunfishApi,
        private nestAuth: NestAuthProvider,
        private nestApiProvider: NestApiProvider,
        private authApi: AuthApi,
        private appPreferences: AppPreferences,
        private sha1: Sha1Service,
        private enkripsiProvider: EnkripsiProvider,
        private platformServiceProvider: PlatformServiceProvider,
        private fcmServiceProvider: FcmServiceProvider,
        private platform: Platform,
        private fcmNative: FcmNative,
        private simProvider: SimProvider,
        private nestResponsesProvider: NestResponsesProvider,
        private globalService: GlobalServiceProvider,
        private attendanceBloc: AttendanceBloc,
        private changePasswordBloc: ChangePasswordBloc,
        private registrationNewApi: RegistrationNewApi,
        private pollingBloc: PollingBloc,
        private recruitmentAuthApi: RecruitmentAuthApi,
        private recruitmentAuth: RecruitmentAuth,
        private changeAccessBloc: ChangeAccessBloc,
        private coreAuthApi: CoreAuthApi,
        private translateService: TranslateService,
        private pageBuilderGlobal: PageBuilderGlobal,
        private shiftscheduleBloc: ShiftscheduleBloc,
    ) {

    }

    /**
     * Saas
     */
    public saas(companyCode: string, useSaas: boolean = false): Observable<any> {
        return Observable.create(async (observer: Subject<any>) => {
            companyCode = companyCode.toLowerCase();
            // const saas = await this.appPreferences.getSaasData();
            // if (saas != null && saas != undefined && !useSaas) {
            //     if (saas.storedPrelogin.IST === companyCode) {
            //         const myObject = {
            //             json: function () {
            //                 return {
            //                     'DATA': saas.storedPrelogin,
            //                     'ERRMSG': '',
            //                     'RESULT': true
            //                 }
            //             }
            //         }
            //         observer.next(myObject)
            //         observer.complete()
            //         return true;
            //     }
            // }

            const headers = new Headers();
            headers.append('Content-Type', 'application/x-www-form-urlencoded');
            const url: string = `https://saas.greatdayhr.com/getPrelogin?account=${btoa(btoa(companyCode).split('').reverse().join(''))}`;
            const url2: string = `https://saasnbc.greatdayhr.com/getPrelogin?account=${btoa(btoa(companyCode).split('').reverse().join(''))}`;
            const url3: string = 'https://saas3.dataon.com/sf6svc/SFCSunFish.cfm?PROVIDER=GetAPIConfig&STRAUTHKEY=9C1C5414B09EE2C0A7925C3FCC7CD25DBF54ECEDBB90BBFDA5C84F1F4CC660B95B6B3AFF2DFB05CC577B12A2ECD8072099BFF8D0CC7A0CAB3B985735&';
            const url4: string = 'https://saas.dataon.com/sf6svc/SFCSunFish.cfm?PROVIDER=GetAPIConfig&STRAUTHKEY=9C1C5414B09EE2C0A7925C3FCC7CD25DBF54ECEDBB90BBFDA5C84F1F4CC660B95B6B3AFF2DFB05CC577B12A2ECD8072099BFF8D0CC7A0CAB3B985735&';
            let errorMessage: any = this.translateService.instant('Failed to connect to the server. Please try again later or contact support us');

            this.http.get(url)
                .timeout(10000)
                .subscribe(async res => {
                    const response: any = res.json();
                    const decryptedData: any = Crypto.AES.decrypt(response.DATA, companyCode).toString(Crypto.enc.Utf8);
                    response.DATA = JSON.parse(decryptedData);
                    const myObject = {
                        json: function () {
                            return response;
                        }
                    }
                    observer.next(myObject)
                    observer.complete()
                }, error => {
                    errorMessage = `${errorMessage} <br/><br/> Code: <br/> SAAS 1: ${error.message}`
                    this.http.get(url2)
                        .timeout(10000)
                        .subscribe(async res => {
                            const response: any = res.json();
                            const decryptedData: any = Crypto.AES.decrypt(response.DATA, companyCode).toString(Crypto.enc.Utf8);
                            response.DATA = JSON.parse(decryptedData);
                            const myObject = {
                                json: function () {
                                    return response;
                                }
                            }
                            observer.next(myObject)
                            observer.complete()
                        }, error2 => {
                            errorMessage = `${errorMessage} <br/> SAAS 2: ${error2.message}`
                            this.http.post(
                                url3,
                                'parameter=' + JSON.stringify({ 'account': companyCode }),
                                { headers: headers })
                                .timeout(10000)
                                .subscribe(res => {
                                    observer.next(res)
                                    observer.complete()
                                }, error3 => {
                                    errorMessage = `${errorMessage} <br/> SAAS 3: ${error3.message}`
                                    this.http.post(
                                        url4,
                                        'parameter=' + JSON.stringify({ 'account': companyCode }),
                                        { headers: headers })
                                        .timeout(10000)
                                        .subscribe(res => {
                                            observer.next(res)
                                            observer.complete()
                                        }, error4 => {
                                            errorMessage = `${errorMessage} <br/> SAAS 4: ${error4.message}`
                                            observer.error(errorMessage)
                                        })
                                })
                        })
                })
        })
    }

    /**
     * Ldap
     */
    public ldap(companyCode: string, useToken: boolean = false): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    if (useToken) {
                        return this.authApi.checkLDAP(companyCode).pipe(
                            map(param => param.data)
                        )
                    } else {
                        return this.authApi.checkLDAPNoToken(companyCode).pipe(
                            map(param => param.data)
                        )
                    }
                } else {
                    return this.sunfishApi.checkLDAP({ ist: companyCode }).pipe(
                        map(param => {
                            if (param.mode == 1 || param.mode == 4) {
                                return true;
                            } else {
                                return false;
                            }
                        })
                    )
                }
            })
    }

    /**
     * Ldap  Username
     */
    public ldapWithUsername(companyCode: string, username?: string): Observable<any> {
        const temp_ist_split = companyCode.trim().split('-');
        if (!isNaN(parseInt(temp_ist_split[0]))) {
            temp_ist_split[0] = 'sfgo' + temp_ist_split[0];
        }
        if (temp_ist_split.length === 1) {
            companyCode = temp_ist_split[0];
        } else {
            companyCode = temp_ist_split.join('-');
        }
        return this.authApi.checkLDAPNoToken(companyCode, username).pipe(
            map(param => param)
        )
    }


    /**
     * Login
     */
    private login(data: LoginRequest): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    if (data.shareAccount) {
                        return this.nestAuth.loginShareAccount(data)
                    } else if (data.tokenPPA) {
                        return this.nestAuth.loginPPA(data)
                    } else if (data.ssoAuthCode) {
                        return this.nestAuth.loginSSO(data)
                    } else if (data.ssoTAM) {
                        return this.nestAuth.loginSSOTAM(data)
                    } else if (data.tokenID) {
                        return this.nestAuth.login(data)
                    } else {
                        return this.nestAuth.login(data)
                    }
                } else {
                    if (data.tokenPPA) {
                        return this.sunfishApi.loginPPA(data)
                    } else {
                        return this.sunfishApi.login(data)
                            .pipe(
                                map(param => {
                                    if (param.status == false) {
                                        if (data.checkonly) {
                                            param.error = "Wrong PIN or Password!";
                                        }
                                        throw Observable.throw({ message: param.error, status: 401, customError: true });
                                    } else {
                                        return param;
                                    }
                                })
                            )
                    }
                }
            })
    }

    /**
     * Logout
     */
    public logout(): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    return this.authApi.logout()
                } else {
                    return this.sunfishApi.logout()
                }
            })
    }

    /**
     * DeepLink
     */
    private deepLink(companyCode: any, accountId: any): Observable<any> {
        return this.registrationNewApi.deeplinkLogin(companyCode, accountId)
    }

    /**
     * Login Data
     */
    private loginData(preloginData: any, token: string): Observable<any> {
        return this.nestAuth.loginData(preloginData.GOPATHNEW, token)
    }

    /**
     * Refresh Data
     */
    private refreshData(body: RequestRefreshTokenDto): Observable<any> {
        return this.authApi.refreshToken(body)
    }

    /**
     * Save Saas Storage
     */
    async saveSaasStorage(data: any): Promise<any> {
        try {
            let saas = await this.appPreferences.getSaasData();
            if (saas == null || saas == undefined) {
                saas = {}
            }
            saas.storedPrelogin = data;
            LoopBackConfig.setBaseURL(data.GOPATH);
            LoopBackConfig.setDefaultPath(data.GOPATH);
            if (data.hasOwnProperty('GOPATHNEW')) {
                this.nestApiProvider.setBaseURL(data.GOPATHNEW);
            }
            await this.appPreferences.setSaasData(saas);
            return;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Form validation
     */
    private validateForm(data: LoginForms): Promise<any> {
        if (data.ist == null || data.ist === undefined || data.ist === 'undefined' || data.ist.trim() == '') {
            throw "Account name is required";
        } else if (data.email.trim() === '' || data.email.trim() === 'undefined') {
            throw "Username is required";
        } else if (!data.tokenPPA && !data.tokenID && (data.password.trim() === '' || data.password.trim() === 'undefined')) {
            if (data.checkonly) {
                throw "Can not be empty for PIN or Password!"
            } else {
                throw "Password is required";
            }
        } else if (isNaN(data.pin)) {
            if (data.checkonly) {
                throw "Can not be empty for PIN or Password!"
            } else {
                throw "PIN is a 6 digit number";
            }
        } else {
            return;
        }
    }

    /**
     * Encription Password
     */
    private async encritpPass(data: LoginForms): Promise<{ pwdHash: string, npwd: string, data: LoginForms }> {
        const temp_ist_split = data.ist.trim().split('-');
        if (!isNaN(parseInt(temp_ist_split[0]))) {
            temp_ist_split[0] = 'sfgo' + temp_ist_split[0];
        }
        if (temp_ist_split.length === 1) {
            data.ist = temp_ist_split[0];
        } else {
            data.ist = temp_ist_split.join('-');
        }
        if (data.email.toLowerCase().includes('|')) {
            const emailTemp = data.email;
            data.shareAccount = emailTemp.split('|')[1];
            data.email = emailTemp.split('|')[0];
        } else {
            if (!data.shareAccount) {
                data.shareAccount = undefined;
            }
            data.email = data.email.trim();
        }
        data.password = (data.password) ? data.password.trim() : data.password;
        const salt = '5unf15h' + data.email + 'D4740N';
        const pwdHash = (data.password) ? this.sha1.getHash(data.password, salt, 7).toUpperCase() : "";
        const npwd =
            (data.password) ? this.sha1.getHash(data.password, salt, 0).toUpperCase() : (data.tokenPPA || data.tokenID) ? data.ist : '';
        return { pwdHash, npwd, data }
    }

    /**
     * Skip saas process
     */
    private async skipProcessSaas(data: LoginForms): Promise<{ skip: boolean, renpwd: string, repwdHash: string, reemail: string, preLogin: any }> {
        if ((data.pin).toString().length > 0) {
            let saas: any = await this.appPreferences.getSaasData();
            const storedPrelogin: any = saas.storedPrelogin;
            const storedPIN: any = saas.storedPIN;
            LoopBackConfig.setBaseURL(storedPrelogin.GOPATH);
            LoopBackConfig.setDefaultPath(storedPrelogin.GOPATH);
            const npwd: string = await this.enkripsiProvider.getEncode(btoa(`SFGO:${data.pin}`), 2)
            const pwdHash: string = storedPIN
            const email: string = await this.enkripsiProvider.getEncode(btoa(`${data.email}:SFGO`), 3)
            return { skip: true, renpwd: npwd, repwdHash: pwdHash, reemail: email, preLogin: storedPrelogin };
        } else if (data.ist.toLowerCase().includes('-intranet')) {
            try {
                const { gopath, sfpath, gdpath } = await this.splitPath(data.ist);
                const companyCode = data.ist.toLowerCase().split('|')[0].split('-')[0];
                let predefinedPrelogin = ({
                    'MODE': [],
                    'ACCOUNT': companyCode,
                    'IST': data.ist,
                    'ACCOUNTNAME': companyCode,
                });
                if (sfpath) predefinedPrelogin['SFPATH'] = sfpath;
                if (gopath) predefinedPrelogin['GOPATH'] = gopath;
                if (gdpath) predefinedPrelogin['GOPATHNEW'] = gdpath;
                await this.saveSaasStorage(predefinedPrelogin);
                LoopBackConfig.setBaseURL(predefinedPrelogin['GOPATH']);
                LoopBackConfig.setDefaultPath(predefinedPrelogin['GOPATH']);
                return { skip: true, renpwd: null, repwdHash: null, reemail: null, preLogin: predefinedPrelogin };
            } catch (error) {
                return { skip: false, renpwd: null, repwdHash: null, reemail: null, preLogin: null };
            }
        } else {
            return { skip: false, renpwd: null, repwdHash: null, reemail: null, preLogin: null };
        }
    }

    /**
     * Saas Process
     */
    public async saasProcess(prelogin_res: any): Promise<any> {
        if (prelogin_res.RESULT === true) {
            const { gopath, sfpath, gdpath } = await this.splitPath(prelogin_res.DATA.IST);
            prelogin_res.DATA.GOPATH = (gopath) ? gopath : prelogin_res.DATA.GOPATH;
            prelogin_res.DATA.SFPATH = (sfpath) ? sfpath : prelogin_res.DATA.SFPATH;
            prelogin_res.DATA.GOPATHNEW = (gdpath) ? gdpath : prelogin_res.DATA.GOPATHNEW;
            if (prelogin_res.DATA.hasOwnProperty('GOPATHNEW')) {
                const gopathNew = prelogin_res.DATA.GOPATHNEW;
                if (!gopathNew || gopathNew == "") {
                    delete prelogin_res.DATA.GOPATHNEW;
                }
            }
            await this.saveSaasStorage(prelogin_res.DATA);
            return prelogin_res.DATA;
        } else {
            throw "Login failed. Network Error";
        }
    }

    /**
     * Ldap Process
     */
    private async ldapProcess(mode: boolean, hash: any, real: any, key?: any): Promise<any> {
        if (mode) {
            if (key) {
                return Crypto.AES.encrypt(btoa(btoa(real).split("").reverse().join("")), key).toString();
            } else {
                return btoa(btoa(real).split("").reverse().join(""));
            }
        } else {
            return hash;
        }
    }

    /**
     * Login Process
     */
    private async loginProcess(response: any, saas: any): Promise<any> {
        response.path = saas.GOPATH;
        response.saasData = saas;
        if (response.error) {
            throw response.error;
        } else {
            if (!response['multiCompany'].company_list) {
                response['multiCompany']['company_list'] = JSON.parse(JSON.stringify(response['multiCompany']['companyList']));
                response['multiCompany']['main_company'] = JSON.parse(JSON.stringify(response['multiCompany']['mainCompany']));
                response['multiCompany']['main_company_code'] = JSON.parse(JSON.stringify(response['multiCompany']['mainCompanyCode']));
                let i = 0;
                for (let item of response['multiCompany']['company_list']) {
                    response['multiCompany']['company_list'][i]['company_code'] = item.companyCode;
                    response['multiCompany']['company_list'][i]['company_id'] = item.companyId;
                    response['multiCompany']['company_list'][i]['company_name'] = item.companyName;
                    i++;
                }
            }

            if (response.socket) {
                const subPath = new URL(saas.GOPATHNEW);
                response.socket.api = saas.GOPATHNEW;
                response.socket.socketUrl = subPath.origin;
                response.socket.socketPath = subPath.pathname != '/' ? `${subPath.pathname}/socket.io` : null;
            }

            if (response.isSF6 == true) {
                response.emailVerified = true;
            }

            try {
                response.menu.intercom = true;
            } catch (error) { }

            response.ttl = parseInt(response.ttl, 0);
            response.rememberMe = true;
            response.user = JSON.stringify(response);

            LoopBackConfig.setBaseURL(response.path);
            LoopBackConfig.setDefaultPath(response.path);
            if (saas.hasOwnProperty('GOPATHNEW')) {
                this.nestApiProvider.setBaseURL(saas.GOPATHNEW);
            }
            await this.appPreferences.setAuth(response);
        }
        return response;
    }

    /**
     * Login Execute
     */
    public async loginExecute(form: LoginForms): Promise<any> {
        try {
            await this.validateForm(form);
            let deviceInfo = await this.appPreferences.getGreatdayStorage<any>(Preference.GDDeviceInfo);
            if (!deviceInfo) {
                deviceInfo = await this.platformServiceProvider.getPlatform();
            }

            try {
                deviceInfo.tokenFCM = await this.fcmNative.getToken();
            } catch (error) {
                deviceInfo.tokenFCM = null;
            }

            const versionApss = {
                code: deviceInfo.SFGOVersionCode,
                number: deviceInfo.SFGOVersionNumber
            }

            let { pwdHash, npwd, data } = await this.encritpPass(form);
            let { skip, renpwd, repwdHash, reemail, preLogin } = await this.skipProcessSaas(data);
            let login: any;
            let saas: any = preLogin;
            const lang = await this.appPreferences.getLanguageData();
            if (skip) {
                (renpwd) ? npwd = renpwd : null;
                (repwdHash) ? pwdHash = repwdHash : null;
                (reemail) ? data.email = reemail : null;
                await this.saveSaasStorage(saas);
                login = await this.login({
                    username: data.email,
                    password: pwdHash,
                    pswd: pwdHash,
                    shareAccount: data.shareAccount,
                    tokenPPA: data.tokenPPA,
                    npwd: npwd,
                    ist: data.ist,
                    preLoginData: preLogin,
                    deviceInfo: deviceInfo,
                    keep: data.keepCheck,
                    versionApps: versionApss,
                    checkonly: form.checkonly,
                    language: lang,
                    ssoAuthCode: data.ssoAuthCode,
                    ssoTAM: data.ssoTAM,
                    tokenID: data.tokenID
                }).toPromise();
            } else {
                if (form.checkonly) {
                    try {
                        if (localStorage.getItem('$account_code_login') && localStorage.getItem('$account_code_login') !== '') {
                            data.ist = localStorage.getItem('$account_code_login');
                        }
                    } catch (error) { }
                }
                saas = await this.saas(data.ist).toPromise();
                saas = await this.saasProcess(saas.json());
                if (!form.ssoAuthCode && !form.ssoTAM) {
                    const ldap = await this.ldapWithUsername(saas.IST, form.email).toPromise().catch(() => { });
                    if (ldap && ldap.uid) {
                        form.email = ldap.uid;
                        const dataEncript = await this.encritpPass(form);
                        pwdHash = dataEncript.pwdHash;
                        npwd = dataEncript.npwd;
                        data = dataEncript.data;
                    }
                    if (ldap && ldap.data) {
                        pwdHash = await this.ldapProcess(ldap, pwdHash, form.password, `${saas.IST}_${data.email}`);
                    }
                }
                if (form.ssoTAM) {
                    pwdHash = await this.ldapProcess(true, pwdHash, form.password, `${saas.IST}_${data.email}`);
                }
                if (form.ssoPayload) {
                    localStorage.setItem('$linkSSO', `${saas.GOPATHNEW}/core/auth/sso/login`);
                }
                login = await this.login({
                    username: data.email,
                    password: pwdHash,
                    pswd: pwdHash,
                    shareAccount: data.shareAccount,
                    tokenPPA: data.tokenPPA,
                    npwd: npwd,
                    ist: data.ist,
                    preLoginData: saas,
                    deviceInfo: deviceInfo,
                    keep: data.keepCheck,
                    versionApps: versionApss,
                    checkonly: form.checkonly,
                    language: lang,
                    ssoAuthCode: data.ssoAuthCode,
                    ssoTAM: data.ssoTAM,
                    ssoPayload: data.ssoPayload,
                    tokenID: data.tokenID
                }).toPromise();
            }

            if (form.checkonly) {
                if (login.hasOwnProperty('status')) {
                    if (login.status) {
                        return true;
                    } else {
                        throw "Wrong PIN or Password!";
                    };
                } else {
                    return true;
                }
            } else {
                // const multipleAccount = await this.appPreferences.getMultipleAccount();
                // if (multipleAccount && multipleAccount.length > 0) {
                //     await this.appPreferences.clearStorage();
                // }

                login = await this.loginProcess(login, saas);
                localStorage.setItem('$account_code', login.companyCode);
                localStorage.setItem('$account_code_login', form.ist);
                localStorage.setItem('$username', form.email);

                this.tokenFCM();
                this.globalService.splashScreenDownload();
                this.attendanceBloc.findAttWorkLocation();
                this.globalService.setRouteFromLogin(true);
                this.changeAccessBloc.saveStorage(login.companySetting);
                this.pageBuilderGlobal.getStorage();
                await this.pollingBloc.getPollingFromServer();
                this.shiftscheduleBloc.setNotificationAttendance();

                if (login.isSF6) {
                    if (login.resetPassword) {
                        login.lifeSpan = true;
                    } else {
                        const lifeSpan = await this.changePasswordBloc.lifeSpanPassword().toPromise().catch(_ => { });
                        if (lifeSpan) {
                            login.lifeSpan = lifeSpan;
                        }
                    }
                }
                return login;
            }
        } catch (error) {
            console.log(error);
            if (typeof error === 'string') {
                throw error;
            } else {
                const message = this.nestResponsesProvider.handleMsgError(error);
                throw message;
            }
        }
    }

    /**
     * DeepLink Proses
     */
    public async deeplinkProcess(companyCode: any, accountId: any): Promise<any> {
        if (!isNaN(parseInt(companyCode))) {
            companyCode = 'sfgo' + companyCode;
        }
        try {
            const deeplink = await this.deepLink(companyCode, accountId).toPromise();
            if (deeplink) {
                return { email: deeplink.email, password: deeplink.password, ist: companyCode }
            } else {
                throw "";
            }
        } catch (error) {
            throw error.message;
        }
    }

    /**
     * IMEI
     */
    async getImei(): Promise<any> {
        return `IMEI: ${await this.platformServiceProvider.getImei()}`
    }

    /**
     * Add FCM
     */
    async tokenFCM(): Promise<any> {
        try {
            if (this.platform.is('cordova')) {
                let fcmdata: any = {
                    app_key: undefined,
                    employee_id: undefined,
                    company_code: undefined,
                    token: undefined,
                    platform: undefined,
                    device_information: undefined
                }
                const device = await this.platformServiceProvider.getPlatform();
                const auth = await this.appPreferences.getAuth();
                fcmdata.token = await this.fcmNative.getToken();
                fcmdata.platform = device.Platform.toLocaleLowerCase();
                fcmdata.employee_id = auth.empId;
                fcmdata.company_code = auth.companyCode;

                console.log('TCL: SET TOKEN', JSON.stringify(fcmdata));
                await this.appPreferences.setFcmData(fcmdata.token);
                return await this.fcmServiceProvider.addUser(fcmdata).toPromise();
            } else {
                return null
            }
        } catch (error) {
            return null
        }
    }

    /**
     * Get Version Apps
     */
    async getAppVersion(): Promise<any> {
        try {
            const version = await this.platformServiceProvider.getPlatform();
            await this.appPreferences.setVersionData(version.SFGOVersionNumber);
            return `${version.SFGOVersionNumber} - ${version.SFGOVersionCode}`;
        } catch (error) {
            return "";
        }
    }

    /**
     * Load Sim Card
     */
    async getSimTranslate(): Promise<any> {
        let country = "en";
        const langId = ['id', 'en', 'th', 'cn', 'kr', 'jp'];
        await this.platform.ready();
        const lang = await this.appPreferences.getLanguageData();
        if (this.platform.is('cordova') && !lang) {
            const data = await this.simProvider.getSimInfo();
            const exist = langId.findIndex(lang => lang == data.countryCode);
            country = exist == -1 ? 'en' : data.countryCode;
        } else if (lang) {
            country = lang;
        }
        return country;
    }

    /**
     * Get PIN
     */
    async getPIN(): Promise<{ mdlist: string, mdlconame: string, mdlpin: string }> {
        let saas = await this.appPreferences.getSaasData();
        if (saas == null || saas == undefined) {
            return {
                mdlist: null,
                mdlconame: null,
                mdlpin: null
            };
        } else {
            return {
                mdlist: saas.storedPrelogin.IST,
                mdlconame: saas.storedPrelogin.ACCOUNTNAME,
                mdlpin: saas.storedPIN
            }
        }
    }

    /**
     * Load Auth
     */
    async loadAuth(refresh: boolean = false): Promise<{ forceLogout: boolean, message: string }> {
        let force = false;
        let message = '';
        try {
            const auth = await this.appPreferences.getAuth();
            const storage = await this.appPreferences.getSaasData();
            let ist = this.convertIST(storage.storedPrelogin.IST);
            try {
                if (localStorage.getItem('$account_code_login') && localStorage.getItem('$account_code_login') !== '') {
                    ist = localStorage.getItem('$account_code_login');
                }
            } catch (error) { }
            let saas = await this.saas(ist).toPromise();
            saas = await this.saasProcess(saas.json());
            if (saas.hasOwnProperty('GOPATHNEW')) {
                let data: any;
                if (refresh) {
                    const body: RequestRefreshTokenDto = {
                        refreshToken: auth.refreshToken,
                        accessToken: auth.id
                    }
                    data = await this.refreshData(body).toPromise();
                } else {
                    data = await this.loginData(saas, auth.id).toPromise();
                }
                await this.loginProcess(data, saas);
                this.changeAccessBloc.saveStorage(data.companySetting);
            } else {
                if (refresh) {
                    force = true;
                } else {
                    LoopBackConfig.setBaseURL(auth.path);
                    LoopBackConfig.setDefaultPath(auth.path);
                    await this.appPreferences.setAuth(auth);
                }
            }
        } catch (error) {
            if (error.error && error.error.message == "Invalid refresh token") {
                force = true;
                message = 'Refresh token can\'t be used! Please re-login to renew and refresh the token.';
            }
        }
        return { forceLogout: force, message }
    }

    /**
    * Load loadAuthSwitchAccount
    */
    async loadAuthSwitchAccount(): Promise<GDAuthInterface> {
        try {
            const auth = await this.appPreferences.getAuth();
            const storage = await this.appPreferences.getSaasData();
            let ist = this.convertIST(storage.storedPrelogin.IST);
            try {
                if (localStorage.getItem('$account_code_login') && localStorage.getItem('$account_code_login') !== '') {
                    ist = localStorage.getItem('$account_code_login');
                }
            } catch (error) { }
            let response: any = {}
            let saas = await this.saas(ist, true).toPromise();
            saas = await this.saasProcess(saas.json());
            if (saas.hasOwnProperty('GOPATHNEW')) {
                let data: any;
                data = await this.loginData(saas, auth.id).toPromise();
                response = await this.loginProcess(data, saas);
                this.changeAccessBloc.saveStorage(data.companySetting);
            } else {
                LoopBackConfig.setBaseURL(auth.path);
                LoopBackConfig.setDefaultPath(auth.path);
                await this.appPreferences.setAuth(auth);
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async switchAccount(account: MultipleAccount) {
        try {
            const ist = this.convertIST(account.companyCode);
            let saas = await this.saas(ist, true).toPromise();
            saas = await this.saasProcess(saas.json());
            const data = await this.authApi.customLoginData(account.gopathNew, account.id);
            localStorage.setItem('$account_code', account.companyCode);
            localStorage.setItem('$account_code_login', ist);
            localStorage.setItem('$username', account.email);
            await this.loginProcess(data, saas);
            await this.appPreferences.setGreatdayStorage(Preference.CompanySetting, data.companySetting);
        } catch (error) {
            throw error;
        }
    }

    /**
     *
     */
    public convertIST(ist: string) {
        const temp_ist_split = ist.trim().split('-');
        if (!isNaN(parseInt(temp_ist_split[0]))) {
            temp_ist_split[0] = 'sfgo' + temp_ist_split[0];
        }
        if (temp_ist_split.length === 1) {
            ist = temp_ist_split[0];
        } else {
            ist = temp_ist_split.join('-');
        }
        return ist;
    }

    /**
     *
     */
    public async splitPath(ist: string): Promise<{ gopath: any, sfpath: any, gdpath: any }> {
        ist = ist + ' ';
        const GOPATH = ist.match(/-go\|(.*?)((-(gd|sf))|\s)/i) ? ist.match(/-go\|(.*?)((-(gd|sf))|\s)/i)[1] : null;
        const GDPATH = ist.match(/-gd\|(.*?)((-(go|sf))|\s)/i) ? ist.match(/-gd\|(.*?)((-(go|sf))|\s)/i)[1] : null;
        const SFPATH = ist.match(/-sf\|(.*?)((-(go|gd))|\s)/i) ? ist.match(/-sf\|(.*?)((-(go|gd))|\s)/i)[1] : null;
        return { gopath: GOPATH, sfpath: SFPATH, gdpath: GDPATH }
    }

    getPathUrl() {
        return new Promise<string>(async (resolve, reject) => {
            try {
                const isGopathNew = await this.nestApiProvider.isGoPathNewExist();
                const SFGoStorage: GDStorageInterface = await this.appPreferences.getSaasData();
                const result = isGopathNew ? SFGoStorage.storedPrelogin.GOPATHNEW : SFGoStorage.storedPrelogin.GOPATH;
                resolve(result);
            }
            catch (error) {
                reject(error);
            }
        })
    }

    // RECRUITMENT
    async loginRecruitment(form: RequestAuth) {
        try {
            let key = this.recruitmentAuth.getKey();
            const path: string = this.recruitmentAuth.getPath();
            if (key.includes('dev-')) {
                const arrKey = key.split('-');
                key = arrKey[1];
            }
            form.device = JSON.stringify(await this.platformServiceProvider.getPlatform());
            const login = await this.recruitmentAuthApi.login(form, key).toPromise();

            // Konsep Recruitment
            await this.recruitmentAuth.setAuthRecruitment(login);

            // Konsep Lama
            const predefinedPrelogin = ({
                'SFPATH': '',
                'MODE': [],
                'ACCOUNT': '',
                'IST': '',
                'ACCOUNTNAME': '',
                'GOPATH': `https://api.greatdayhr.com/${path}`,
                'GOPATHNEW': `https://api.greatdayhr.com/${path}`
            })
            await this.saveSaasStorage(predefinedPrelogin);
            let response: any = {};
            response.id = login.data.token;
            response.ttl = 90000;
            response.rememberMe = true;
            response.user = JSON.stringify(login.data.profile);

            LoopBackConfig.setBaseURL(predefinedPrelogin.GOPATH);
            LoopBackConfig.setDefaultPath(predefinedPrelogin.GOPATH);
            if (predefinedPrelogin.hasOwnProperty('GOPATHNEW')) {
                this.nestApiProvider.setBaseURL(predefinedPrelogin.GOPATHNEW);
            }
            await this.appPreferences.setAuth(response);

            return login;
        } catch (error) {
            if (typeof error === 'string') {
                throw error;
            } else {
                const message = this.nestResponsesProvider.handleMsgError(error);
                throw message;
            }
        }
    }

    async registerRecruitment(email: string, password: string, nik: string) {
        try {
            let key = this.recruitmentAuth.getKey();
            if (key.includes('dev-')) {
                const arrKey = key.split('-');
                key = arrKey[1];
            }
            if (email.trim() === '' || email.trim() === 'undefined') {
                throw "Email is required";
            }
            if (nik.trim() === '' || nik.trim() === 'undefined') {
                throw "NIK is required";
            }
            if (password.trim() === '' || password.trim() === 'undefined') {
                throw "Password is required";
            }
            if (key) {
                const register = await this.recruitmentAuthApi.register(email, password, nik, key).toPromise();
                return this.nestResponsesProvider.handleMsgError(register);
            } else {
                throw 'The invitation key was not found';
            }
        } catch (error) {
            if (typeof error === 'string') {
                throw error;
            } else {
                throw this.nestResponsesProvider.handleMsgError(error);
            }
        }
    }

    async logoutRecruitment() {
        try {
            const logout = await this.recruitmentAuthApi.logout().toPromise();
            return this.nestResponsesProvider.handleMsgError(logout);
        } catch (error) {
            if (typeof error === 'string') {
                throw error;
            } else {
                throw this.nestResponsesProvider.handleMsgError(error);
            }
        }
    }

    async setKeyRecruitment(key: string) {
        return this.recruitmentAuth.setKey(key);
    }

    isHRAdmin() {
        return new Promise<boolean>((resolve, reject) => {
            this.isHRAdminApi()
                .subscribe(
                    result => resolve(result),
                    error => reject(error))
        })
    }

    private isHRAdminApi() {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(
                isGoPathNewExist => {
                    if (isGoPathNewExist) {
                        return this.authApi.isHRAdmin().pipe(map(result => result.data))
                    } else {
                        return this.sunfishApi.isHRAdmin().pipe(map(result => result.result));
                    }
                }
            )
    }

    async switchLanguage(language: string) {
        try {
            await this.authApi.switchLanguage({ language }).toPromise();
        } catch (error) {
            console.log(error);
        }
    }

    async validatePassword(form: LoginForms): Promise<any> {
        try {
            return await this.loginExecute(form);
        } catch (error) {
            if (typeof error === 'string') {
                throw error;
            } else {
                const message = this.nestResponsesProvider.handleMsgError(error);
                throw message;
            }
        }
    }

    async interceptorRefreshLogin(): Promise<any> {
        try {
            const res = await this.loadAuth(true);
            if (res.forceLogout) {
                throw false;
            } else {
                return true;
            }
        } catch (error) {
            throw error;
        }
    }

    async legacyLogin(data: LegacyPageOptions): Promise<any> {
        try {
            localStorage.clear();
            await this.storage.clear();

            await this.appPreferences.setAuth(data.auth);
            await this.appPreferences.setSaasData(data.saas);
            localStorage.setItem('$account_code_login', data.companyCodeLogin);
            localStorage.setItem('$account_code', data.companyCode);
            localStorage.setItem('$username', data.username);
            localStorage.setItem('webOpenFromWebview', 'true');
            
            try {
                this.storage.set('pageBuilderAppMode', data.appMode);
            } catch (error) {
                console.log('TCL: error set appmode', error);
            }

            try {
                this.translateService.use(data.language);
                await this.appPreferences.setLanguageData(data.language);
                await this.pageBuilderGlobal.getStorage();
            } catch (error) {
                console.log('TCL: error set language', error);
            }

            const res = await this.loadAuth();
            if (res.forceLogout) {
                throw false;
            } else {
                return true;
            }
        } catch (error) {
            throw error;
        }
    }

    async getLinkLists(companyCode: string, email: string): Promise<{ provider: any, link: any }[]> {
        try {
            const form: any = {
                coname: "",
                pin: "",
                ist: companyCode,
                email: email,
                password: null,
                keepCheck: true,
                shareAccount: undefined
            }
            let { pwdHash, npwd, data } = await this.encritpPass(form);
            const { skip, renpwd, repwdHash, reemail, preLogin } = await this.skipProcessSaas(data);
            console.log(pwdHash, npwd, renpwd, repwdHash, reemail, preLogin);
            if (skip) {
                throw 'Error';
            }
            const saas = await this.saas(data.ist).toPromise();
            await this.saasProcess(saas.json());
            const temp_ist_split = data.ist.trim().split('-');
            data.ist = temp_ist_split[0];
            const dataLinks = await this.coreAuthApi.listsLogin(data.ist).toPromise();
            if (dataLinks.data.length > 0) {
                return dataLinks.data;
            } else {
                throw 'Error';
            }
        } catch (error) {
            throw error;
        }
    }

    /**
     * Payload Login
     */
    public async getPayloadLogin(form: LoginForms): Promise<any> {
        try {
            await this.validateForm(form);
            let deviceInfo = await this.appPreferences.getGreatdayStorage<any>(Preference.GDDeviceInfo);
            if (!deviceInfo) {
                deviceInfo = await this.platformServiceProvider.getPlatform();
            }

            try {
                deviceInfo.tokenFCM = await this.fcmNative.getToken();
            } catch (error) {
                deviceInfo.tokenFCM = null;
            }

            const versionApss = {
                code: deviceInfo.SFGOVersionCode,
                number: deviceInfo.SFGOVersionNumber
            }

            let { pwdHash, npwd, data } = await this.encritpPass(form);
            const { skip, renpwd, repwdHash, reemail, preLogin } = await this.skipProcessSaas(data);
            let saas: any = preLogin;
            const lang = await this.appPreferences.getLanguageData();
            if (skip) {
                (renpwd) ? npwd = renpwd : null;
                (repwdHash) ? pwdHash = repwdHash : null;
                (reemail) ? data.email = reemail : null;
                await this.saveSaasStorage(saas);
                return {
                    username: data.email,
                    password: pwdHash,
                    shareAccount: data.shareAccount,
                    tokenPPA: data.tokenPPA,
                    npwd: npwd,
                    ist: data.ist,
                    preLoginData: preLogin,
                    deviceInfo: deviceInfo,
                    keep: data.keepCheck,
                    versionApps: versionApss,
                    checkonly: form.checkonly,
                    language: lang,
                    ssoAuthCode: data.ssoAuthCode,
                    tokenID: data.tokenID
                };
            } else {
                if (form.checkonly) {
                    try {
                        if (localStorage.getItem('$account_code_login') && localStorage.getItem('$account_code_login') !== '') {
                            data.ist = localStorage.getItem('$account_code_login');
                        }
                    } catch (error) { }
                }
                saas = await this.saas(data.ist).toPromise();
                saas = await this.saasProcess(saas.json());
                const ldap = await this.ldap(saas.IST).toPromise().catch(() => { });
                if (ldap) {
                    pwdHash = await this.ldapProcess(ldap, pwdHash, form.password, `${saas.IST}_${data.email}`);
                }
                return {
                    username: data.email,
                    password: pwdHash,
                    pswd: pwdHash,
                    shareAccount: data.shareAccount,
                    tokenPPA: data.tokenPPA,
                    npwd: npwd,
                    ist: data.ist,
                    preLoginData: saas,
                    deviceInfo: deviceInfo,
                    keep: data.keepCheck,
                    versionApps: versionApss,
                    checkonly: form.checkonly,
                    language: lang,
                    ssoAuthCode: data.ssoAuthCode,
                    tokenID: data.tokenID
                }
            }
        } catch (error) {
            if (typeof error === 'string') {
                throw error;
            } else {
                const message = this.nestResponsesProvider.handleMsgError(error);
                throw message;
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/bloc/authentication/authentication.bloc.ts